import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
import { parsePhoneNumber } from 'libphonenumber-js/max';
import { PhoneType } from '@isyc-react/types/core';
export const personPhoneToString = phone => `${phone.prefix} ${phone.number}`;
export const personPhoneToPhoneItem = phone => {
  var _phone$prefix$replace, _phone$prefix;
  return {
    prefix: (_phone$prefix$replace = (_phone$prefix = phone.prefix) === null || _phone$prefix === void 0 ? void 0 : _phone$prefix.replaceAll('+', '')) !== null && _phone$prefix$replace !== void 0 ? _phone$prefix$replace : '',
    number: phone.number
  };
};
export const phoneItemToString = phone => `+${phone.prefix}${phone.number}`;
export const phoneItemToPersonPhone = (phone, principal, defaultCountry) => stringToPersonPhone(phoneItemToString(phone), principal, defaultCountry);
export const stringToPersonPhone = (phone, principal, defaultCountry) => {
  if (!phone) return null;
  try {
    const phoneNumber = parsePhoneNumber(phone, defaultCountry);
    if (!phoneNumber || !phoneNumber.isValid()) return null;
    const type = phoneNumber.getType() === 'MOBILE' ? PhoneType.mobile : PhoneType.landline;
    const prefix = `+${phoneNumber.countryCallingCode}`;
    const number = phoneNumber.nationalNumber;
    return {
      number,
      prefix,
      type,
      principal: principal !== null && principal !== void 0 ? principal : false
    };
  } catch (e) {
    return null;
  }
};
export const stringToPhoneItem = (phone, defaultCountry) => {
  if (!phone) return null;
  try {
    const phoneNumber = parsePhoneNumber(phone, defaultCountry);
    if (!phoneNumber || !phoneNumber.isValid()) return null;
    const prefix = phoneNumber.countryCallingCode.toString();
    const number = phoneNumber.nationalNumber;
    return {
      number,
      prefix
    };
  } catch (e) {
    return null;
  }
};
export const defaultCountryPhoneMask = '... ... ...';
export const countryPhoneMasks = {
  AR: '(..) ........',
  AU: '(..) .... ....',
  AZ: '(..) ... .. ..',
  BE: '... .. .. ..',
  BR: '(..) .........',
  BY: '(..) ... .. ..',
  CA: '(...) ...-....',
  CH: '.. ... .. ..',
  CI: '.. .. .. .. ..',
  CN: '..-.........',
  CO: '... ... ....',
  CR: '....-....',
  CY: '.. ......',
  DE: '.... ........',
  DK: '.. .. .. ..',
  EE: '.... ......',
  ES: '... ... ...',
  FI: '.. ... .. ..',
  FR: '. .. .. .. ..',
  GB: '.... ......',
  GT: '....-....',
  HK: '.... ....',
  HT: '....-....',
  IE: '.. .......',
  IL: '... ... ....',
  IN: '.....-.....',
  IR: '... ... ....',
  IS: '... ....',
  IT: '... .......',
  JP: '.. .... ....',
  KR: '... .... ....',
  KZ: '... ...-..-..',
  MD: '(..) ..-..-..',
  MX: '... ... ....',
  MY: '..-....-....',
  NL: '.. ........',
  NO: '... .. ...',
  NZ: '...-...-....',
  PH: '.... .......',
  PK: '...-.......',
  PL: '...-...-...',
  RU: '(...) ...-..-..',
  SE: '(...) ...-...',
  SG: '....-....',
  SV: '....-....',
  TR: '... ... .. ..',
  UA: '(..) ... .. ..',
  US: '(...) ...-....',
  VA: '.. .... ....'
};
export const formatPhoneNumber = (number, country, enableLongNumbers = true) => {
  var _countryPhoneMasks$co;
  if (number && number.length < 2) return number;
  const format = (_countryPhoneMasks$co = countryPhoneMasks[country]) !== null && _countryPhoneMasks$co !== void 0 ? _countryPhoneMasks$co : defaultCountryPhoneMask;
  const formattedObject = Array.from(format).reduce((acc, character) => {
    if (acc.remainingText.length === 0) {
      return acc;
    }
    if (character !== '.') {
      return {
        formattedText: acc.formattedText + character,
        remainingText: acc.remainingText
      };
    }
    const [head, ...tail] = acc.remainingText;
    return {
      formattedText: acc.formattedText + head,
      remainingText: tail
    };
  }, {
    formattedText: '',
    remainingText: Array.from(number)
  });
  let formattedNumber = formattedObject.formattedText;
  if (enableLongNumbers) {
    formattedNumber = formattedObject.formattedText + formattedObject.remainingText.join('');
  }
  if (formattedNumber.includes('(') && !formattedNumber.includes(')')) formattedNumber += ')';
  return formattedNumber;
};
export const unformatPhoneNumber = formattedNumber => formattedNumber.replace(/[^0-9]+/g, '');